import {
  createVivaIntegration,
  createPersonalkollenIntegration,
  getIntegrationsList,
  getVivaIntegrationStatus,
  updateVivaIntegration,
  updatePersonalkollenIntegration,
} from '../../api/integration';
import { VivaISVTurnover } from '../../constants/isv';
import { IntegrationViva, IntegrationPersonalkollen } from '../../model/Integration';
import invalidationManager from './InvalidationManager';

const { hook: useIntegrationsList } = invalidationManager.createFetcher({
  queryKey: (companyId: string) => ['company', companyId, 'integrations'],
  fetchFunction: async (companyId: string) => {
    return getIntegrationsList(companyId);
  },
});

const useCreateVivaIntegration = invalidationManager.createMutationHook({
  mutationFunction: async (
    companyId: string,
    data: {
      turnover: VivaISVTurnover;
      terminalFee: number;
    },
  ) => {
    await createVivaIntegration(companyId, data);
    await invalidationManager.invalidate(['company', companyId, 'integrations']);
  },
});

const useCreatePersonalkollenIntegration = invalidationManager.createMutationHook({
  mutationFunction: async ({ companyId, apiKey }: { companyId: string; apiKey: string }) => {
    await createPersonalkollenIntegration(companyId, apiKey);
    await invalidationManager.invalidate(['company', companyId, 'integrations']);
    await invalidationManager.invalidate(['company', companyId, 'billingItems']);
  },
});

const useVivaIntegrationStatus = invalidationManager.createMutationHook({
  mutationFunction: async (companyId: string, integrationId: string) => {
    if (!integrationId) {
      return;
    }
    await getVivaIntegrationStatus(companyId, integrationId);
    await invalidationManager.invalidate(['company', companyId, 'integrations']);
  },
});

const useUpdateVivaIntegrationMutation = invalidationManager.createMutationHook({
  mutationFunction: async (
    companyId: string,
    integrationId: string,
    data: Partial<IntegrationViva>,
  ) => {
    await updateVivaIntegration(companyId, integrationId, data);
    await invalidationManager.invalidate(['company', companyId, 'integrations']);
  },
});

const useUpdatePersonalkollenIntegrationMutation = invalidationManager.createMutationHook({
  mutationFunction: async (
    companyId: string,
    integrationId: string,
    data: Partial<IntegrationPersonalkollen>,
  ) => {
    await updatePersonalkollenIntegration(companyId, integrationId, data);
    await invalidationManager.invalidate(['company', companyId, 'integrations']);
  },
});

export {
  useIntegrationsList,
  useCreateVivaIntegration,
  useCreatePersonalkollenIntegration,
  useVivaIntegrationStatus,
  useUpdateVivaIntegrationMutation,
  useUpdatePersonalkollenIntegrationMutation,
};
